import { Photo, PrintSize } from '../types';

export const printSizes: PrintSize[] = [
  {
    id: 'small',
    name: 'Small',
    dimensions: '29.7 × 42.0 cm',
    dimensionsInches: '11.7 × 16.5 in',
    price: 70,
    available: 10
  },
  {
    id: 'medium',
    name: 'Medium',
    dimensions: '42.0 × 59.4 cm',
    dimensionsInches: '16.5 × 23.4 in',
    price: 100,
    available: 10
  },
  {
    id: 'large',
    name: 'Large',
    dimensions: '84.1 × 118.9 cm',
    dimensionsInches: '33.1 × 46.8 in',
    price: 120,
    available: 10
  }
];

export const photos: Photo[] = [
  {
    id: '1',
    title: 'Sunset Landscape',
    description: 'Magnificent landscape in golden sunset light. Perfect for living rooms and offices. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1544954617-f5c6b0d16164?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsYW5kc2NhcGUlMjBwaG90b2dyYXBoeXxlbnwxfHx8fDE3NjE4NjA2NTB8MA&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Landscape',
    orientation: 'landscape',
    sizes: [...printSizes]
  },
  {
    id: '2',
    title: 'Wild Bird',
    description: 'Nature photograph of wild bird in natural setting. Exceptionally sharp and stunning image. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1622399726160-f7748e75272c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxuYXR1cmUlMjB3aWxkbGlmZXxlbnwxfHx8fDE3NjE4NTc5ODh8MA&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Nature',
    orientation: 'portrait',
    sizes: [...printSizes]
  },
  {
    id: '3',
    title: 'City Architecture',
    description: 'Modern architectural art in the city center. Perfect for design studios and businesses. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1617381519460-d87050ddeb92?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaXR5JTIwYXJjaGl0ZWN0dXJlfGVufDF8fHx8MTc2MTgwOTk1Nnww&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Architecture',
    orientation: 'landscape',
    sizes: [...printSizes]
  },
  {
    id: '4',
    title: 'Portrait',
    description: 'Professional portrait with dramatic lighting. Exceptionally crafted work. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1544124094-8aea0374da93?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMHBob3RvZ3JhcGh5fGVufDF8fHx8MTc2MTg3ODE2OXww&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Portrait',
    orientation: 'portrait',
    sizes: [...printSizes]
  },
  {
    id: '5',
    title: 'Abstract Colors',
    description: 'Abstract artwork that adds color and life to any space. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1615184697985-c9bde1b07da7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFydHxlbnwxfHx8fDE3NjE4MzQzMTN8MA&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Abstract',
    orientation: 'square',
    sizes: [...printSizes]
  },
  {
    id: '6',
    title: 'The Waves',
    description: 'The ocean in all its glory. Calming and powerful image in one. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1514747975201-4715db583da9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxvY2VhbiUyMHdhdmVzfGVufDF8fHx8MTc2MTg0MTExMXww&ixlib=rb-4.1.0&q=80&w=1080',
    category: 'Nature',
    orientation: 'landscape',
    sizes: [...printSizes]
  },
  {
    id: '7',
    title: 'Minimalist Space',
    description: 'Modern architecture with clean lines. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYXJjaGl0ZWN0dXJlfGVufDF8fHx8MTc2MTg3ODY1OXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    category: 'Architecture',
    orientation: 'portrait',
    sizes: [...printSizes]
  },
  {
    id: '8',
    title: 'Mountain Range',
    description: 'Magnificent mountain landscape. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1604223190546-a43e4c7f29d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3VudGFpbiUyMGxhbmRzY2FwZXxlbnwxfHx8fDE3NjE4NjkyNjh8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    category: 'Landscape',
    orientation: 'landscape',
    sizes: [...printSizes]
  },
  {
    id: '9',
    title: 'Forest Lands',
    description: 'Peaceful forest in natural light. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1759066914561-c1bde5bc924c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmb3Jlc3QlMjBuYXR1cmV8ZW58MXx8fHwxNzYxODg3MDQzfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    category: 'Nature',
    orientation: 'portrait',
    sizes: [...printSizes]
  },
  {
    id: '10',
    title: 'The Desert',
    description: 'Dramatic desert landscape. Printed on high-quality paper with professional photography printing.',
    imageUrl: 'https://images.unsplash.com/photo-1617374128851-c84e37dc9f37?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkZXNlcnQlMjBsYW5kc2NhcGV8ZW58MXx8fHwxNzYxODM0NjM1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
    category: 'Landscape',
    orientation: 'landscape',
    sizes: [...printSizes]
  }
];